import { render } from "./EmpresaRootDetalheView.vue?vue&type=template&id=30d663da&scoped=true"
import script from "./EmpresaRootDetalheView.vue?vue&type=script&lang=js"
export * from "./EmpresaRootDetalheView.vue?vue&type=script&lang=js"

import "./EmpresaRootDetalheView.vue?vue&type=style&index=0&id=30d663da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d663da"]])

export default __exports__